module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.$route.params.id != 'new') ? _c('ul', {
    staticClass: "tab-buttons"
  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      class: {
        active: _vm.$route.params.tab == tab.path
      }
    }, [_c('router-link', {
      attrs: {
        "to": tab.path
      }
    }, [_c('i', {
      staticClass: "fa",
      class: tab.icon
    }), _vm._v("\n\t\t\t\t" + _vm._s(tab.label) + "\n\t\t\t\t"), (tab.bubble > 0) ? _c('span', {
      staticClass: "notification-bubble"
    }, [_vm._v(_vm._s(tab.bubble))]) : _vm._e()])], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0488acfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavTabs.vue
// module id = 261
// module chunks = 0